import React from "react";
import logoSrc from "../../assets/mandapai-logo.png";

/**
 * MandapAI — brand logo.
 *
 * The official badge: the MandapAI wordmark on a white rounded square with
 * the brand gradient border. The same artwork is used for the app icon.
 *
 * Props
 *  - theme:   "light" (for light backgrounds) | "dark" (for dark backgrounds)
 *  - size:    nominal height in px (the badge scales with it)
 *  - tagline: render the "Event Marketplace" tagline beside the badge
 */
const Logo = ({
  theme = "light",
  size = 40,
  tagline = false,
  className = "",
  onClick,
}) => {
  const dark = theme === "dark";
  const box = Math.round(size * 1.3);

  return (
    <div
      className={`flex items-center gap-3 leading-none ${
        onClick ? "cursor-pointer" : ""
      } ${className}`}
      onClick={onClick}
    >
      <img
        src={logoSrc}
        alt="MandapAI"
        width={box}
        height={box}
        className="flex-shrink-0 select-none"
        style={{ width: box, height: box }}
        draggable={false}
      />
      {tagline && (
        <div
          className={`font-['Inter'] font-medium tracking-[0.18em] uppercase ${
            dark ? "text-gray-400" : "text-gray-500"
          }`}
          style={{ fontSize: size * 0.22 }}
        >
          Event Marketplace
        </div>
      )}
    </div>
  );
};

export default Logo;
